export const SCRIPT_ID = 'ze-snippet'

export const PAGE_FIELD_ID = '12441349780252'

export const ZENDESK_KEY = '78875914-d647-4fd9-b03f-0ebc4a41b939'

export const ASSETS_URL = 'https://static.zdassets.com/ekr/snippet.js'
